import db from '@helpers/firebase/Firestore';
import { firestore } from '@helpers/firebase/Initialize';

export async function isPlanExists(planId: string) {
  const docSnap = await db.getDoc(db.doc(firestore, 'plans', planId));
  return docSnap.exists();
}

export async function isPlanUserInviteExists(planId: string, userId: string) {
  const doc = await db.getDoc(db.doc(firestore, 'plans', planId, 'userInvites', userId));
  return doc.exists();
}
